import React, { useState } from 'react';
import { connect } from 'react-redux';
import GLOBAL_STYLES from '../styles';
import { app, main } from '../state/actions';
import ToolbarButton from './ToolbarButton';
import {
  convertTimestampMD,
  getAcronym,
  typeToColorMap,
  cmp,
  isArrayEqual,
  buildGradientString,
  adjustSchedule,
} from '../helpers/misc';
import {
  getDynamoDBClient,
  putScheduleItem,
  deleteScheduleItem,
  getMachineScheduleRows,
} from '../helpers/ddb';
import ReleasedJob from './ReleasedJob';
import ScheduledJob from './ScheduledJob';
import CurrentJob from './CurrentJob';
import Stoppage from './Stoppage';
import { Button, Form } from 'react-bootstrap';
import cloneDeep from 'lodash.clonedeep';
import DatePicker from 'react-datepicker';
import { v4 as uuid } from 'uuid';
import JobNotesModal from './JobNotesModal';


const mapStateToProps = state => ({
  colorScheme: state.main.colorScheme,
  credentials: state.main.credentials,
  authorizedModules: state.main.authorizedModules,
  loggedInUser: state.main.loggedInUser,
  windowDimensions: state.main.windowDimensions,
  openMachine: state.app.openMachine,
  openMachineSelectedJob: state.app.openMachineSelectedJob,
  machineData: state.app.machineData,
  insertJobType: state.app.insertJobType,
  locationData: state.app.locationData,
});

const mapDispatchToProps = dispatch => ({
  updateOpenMachine: payload => dispatch(app.updateOpenMachine(payload)),
  updateMachineData: payload => dispatch(app.updateMachineData(payload)),
  updateLoadingMessage: payload => dispatch(main.updateLoadingMessage(payload)),
  updateOpenMachineSelectedJob: payload => dispatch(app.updateOpenMachineSelectedJob(payload)),
  updateInsertJobType: payload => dispatch(app.updateInsertJobType(payload)),
});

const EditSchedule = props => {
  const {
    colorScheme,
    openMachine,
    updateOpenMachine,
    windowDimensions,
    timeNow,
    openMachineSelectedJob,
    updateLoadingMessage,
    updateMachineData,
    machineData,
    updateOpenMachineSelectedJob,
    insertJobType,
    updateInsertJobType,
    credentials,
    locationData,
    loggedInUser,
    authorizedModules,
  } = props;
  const [selectedStoppageReason, setSelectedStoppageReason] = useState('NO SCHEDULE');
  const [stoppageTime, setStoppageTime] = useState('1.0');
  const [stoppageStartTime, setStoppageStartTime] = useState(null);
  
  const totalTime = openMachine ?
    openMachine.newSchedule.reduce((total, cur) => total + (cur.endTime - cur.startTime), 0) :
    1;
  
  const handleInsert = (jobArrIndex, index) => {
    if(jobArrIndex === 'STOPPAGE') insertStoppage(index);
    else insertJob(jobArrIndex, index);
  };
  
  const insertStoppage = index => {
    try {
      updateLoadingMessage('Inserting stoppage');
      const indexOfMachine = machineData.findIndex(m => m.serialNumber === openMachine.serialNumber);
      let newOpenMachine = cloneDeep(openMachine);
      const startTime = insertJobType === 'STATIC' ?
        stoppageStartTime.getTime() < timeNow ?
          timeNow :
          stoppageStartTime.getTime() :
        index === 0 ?
          timeNow :
          newOpenMachine.newSchedule[index - 1].endTime;
      const duration = parseFloat(stoppageTime) * 3600000;
      const newRecord = {
        dynamicStartTime: startTime,
        endTime: startTime + duration,
        machineCommonName: openMachine.commonName,
        machineLocator: openMachine.machineLocator,
        machineSerialNumber: openMachine.serialNumber,
        schedulingId: uuid(),
        startTime: startTime,
        isStoppage: true,
        stoppageReason: selectedStoppageReason,
      };
      if(insertJobType === 'STATIC') newRecord.staticStartTime = startTime;
      if(insertJobType === 'DYNAMIC') newOpenMachine.newSchedule.splice(index, 0, newRecord);
      else newOpenMachine.newSchedule.push(newRecord);
      newOpenMachine.newSchedule = adjustSchedule(newOpenMachine.newSchedule, newOpenMachine.jobs, newOpenMachine.standards, timeNow);
      const newMachineData = cloneDeep(machineData);
      newMachineData[indexOfMachine] = newOpenMachine;
      updateOpenMachineSelectedJob(null);
      updateMachineData(newMachineData);
      updateOpenMachine(newOpenMachine);
      setSelectedStoppageReason('NO SCHEDULE');
      setStoppageTime('1.0');
      setStoppageStartTime(null);
    }
    catch(e) {
      console.error('insertStoppage error ->', e);
    }
    finally {
      updateLoadingMessage(null);
    }
  };
  
  const insertJob = (jobArrIndex, index, staticStartTime) => {
    try {
      updateLoadingMessage('Inserting job');
      const indexOfMachine = machineData.findIndex(m => m.serialNumber === openMachine.serialNumber);
      let newOpenMachine = cloneDeep(openMachine);
      let jobArr = newOpenMachine.newReleasedJobs.splice(jobArrIndex, 1)[0];
      const newRecord = {
        dynamicStartTime: staticStartTime ?
          staticStartTime :
          index === 0 ? timeNow : newOpenMachine.newSchedule[index - 1].endTime,
        endTime: staticStartTime ?
          staticStartTime + jobArr[0].stdRunTime :
          index === 0 ?
            timeNow + jobArr[0].stdRunTime :
            newOpenMachine.newSchedule[index - 1].endTime + jobArr[0].stdRunTime,
        jobNumbers: jobArr.map(j => j.jobNumber),
        machineCommonName: openMachine.commonName,
        machineLocator: openMachine.machineLocator,
        machineSerialNumber: openMachine.serialNumber,
        schedulingId: jobArr.map(j => j.jobNumber).join('|'),
        startTime: staticStartTime ?
          staticStartTime :
          index === 0 ? timeNow : newOpenMachine.newSchedule[index - 1].endTime,
      };
      if(staticStartTime) newRecord.staticStartTime = staticStartTime;
      if(index != null) newOpenMachine.newSchedule.splice(index, 0, newRecord);
      else newOpenMachine.newSchedule.push(newRecord);
      newOpenMachine.newSchedule = adjustSchedule(newOpenMachine.newSchedule, newOpenMachine.jobs, newOpenMachine.standards, timeNow);
      const newMachineData = cloneDeep(machineData);
      newMachineData[indexOfMachine] = newOpenMachine;
      updateOpenMachineSelectedJob(null);
      updateMachineData(newMachineData);
      updateOpenMachine(newOpenMachine);
    }
    catch(e) {
      console.error('insertJob error ->', e);
    }
    finally {
      updateLoadingMessage(null);
    }
  };
  
  const updateNote = (newJobNote, index) => {
    const indexOfMachine = machineData.findIndex(m => m.serialNumber === openMachine.serialNumber);
    let newOpenMachine = cloneDeep(openMachine);
    newOpenMachine.newSchedule[index].notes = newJobNote.trim();
    const newMachineData = cloneDeep(machineData);
    newMachineData[indexOfMachine] = newOpenMachine;
    updateMachineData(newMachineData);
    updateOpenMachine(newOpenMachine);
  };
  
  const updatePriority = (priority, index) => {
    const indexOfMachine = machineData.findIndex(m => m.serialNumber === openMachine.serialNumber);
    let newOpenMachine = cloneDeep(openMachine);
    newOpenMachine.newSchedule[index].isPriority = priority;
    const newMachineData = cloneDeep(machineData);
    newMachineData[indexOfMachine] = newOpenMachine;
    updateMachineData(newMachineData);
    updateOpenMachine(newOpenMachine);
  };
  
  const updateEngineerStartup = (engineerStart, index) => {
    const indexOfMachine = machineData.findIndex(m => m.serialNumber === openMachine.serialNumber);
    let newOpenMachine = cloneDeep(openMachine);
    newOpenMachine.newSchedule[index].isEngineerStartup = engineerStart;
    const newMachineData = cloneDeep(machineData);
    newMachineData[indexOfMachine] = newOpenMachine;
    updateMachineData(newMachineData);
    updateOpenMachine(newOpenMachine);
  };
  
  const updateShifts = (shiftArr, index) => {
    const indexOfMachine = machineData.findIndex(m => m.serialNumber === openMachine.serialNumber);
    let newOpenMachine = cloneDeep(openMachine);
    newOpenMachine.newSchedule[index].shifts = shiftArr;
    newOpenMachine.newSchedule = adjustSchedule(newOpenMachine.newSchedule, newOpenMachine.jobs, newOpenMachine.standards, timeNow);
    const newMachineData = cloneDeep(machineData);
    newMachineData[indexOfMachine] = newOpenMachine;
    updateMachineData(newMachineData);
    updateOpenMachine(newOpenMachine);
  };
  
  const removeJob = (index, jobArr) => {
    try {
      updateLoadingMessage('Removing job');
      const indexOfMachine = machineData.findIndex(m => m.serialNumber === openMachine.serialNumber);
      let newOpenMachine = cloneDeep(openMachine);
      newOpenMachine.newSchedule.splice(index, 1);
      newOpenMachine.newSchedule = adjustSchedule(newOpenMachine.newSchedule, newOpenMachine.jobs, newOpenMachine.standards, timeNow);
      newOpenMachine.newReleasedJobs.push(jobArr);
      newOpenMachine.newReleasedJobs.sort((a, b) => cmp(a[0].scheduledStartDate, b[0].scheduledStartDate));
      const newMachineData = cloneDeep(machineData);
      newMachineData[indexOfMachine] = newOpenMachine;
      updateMachineData(newMachineData);
      updateOpenMachine(newOpenMachine);
    }
    catch(e) {
      console.error('removeJob error ->', e);
    }
    finally {
      updateLoadingMessage(null);
    }
  };
  
  const removeStoppage = index => {
    try {
      updateLoadingMessage('Removing stoppage');
      const indexOfMachine = machineData.findIndex(m => m.serialNumber === openMachine.serialNumber);
      let newOpenMachine = cloneDeep(openMachine);
      newOpenMachine.newSchedule.splice(index, 1);
      newOpenMachine.newSchedule = adjustSchedule(newOpenMachine.newSchedule, newOpenMachine.jobs, newOpenMachine.standards, timeNow);
      const newMachineData = cloneDeep(machineData);
      newMachineData[indexOfMachine] = newOpenMachine;
      updateMachineData(newMachineData);
      updateOpenMachine(newOpenMachine);
    }
    catch(e) {
      console.error('removeStoppage error ->', e);
    }
    finally {
      updateLoadingMessage(null);
    }
  };
  
  const changed = openMachine &&
    !isArrayEqual(openMachine.schedule.filter(s => !s.isGenerated), openMachine.newSchedule.filter(s => !s.isGenerated));
  
  const handleCloseClick = () => {
    if((changed && window.confirm('Are you sure you want to close? You will lose your unsaved changes!')) || !changed) {
      resetChanges();
      updateOpenMachine(null);
    }
  };
  
  const handleSaveClick = async () => {
    try {
      updateLoadingMessage('Saving');
      const newRecords = openMachine.newSchedule.filter(s => !s.isGenerated);
      const ddb = getDynamoDBClient(credentials);
      const now = Date.now();
      const currentScheduleRecords = await getMachineScheduleRows(ddb, openMachine.serialNumber);
      await Promise.all(currentScheduleRecords.map(record => deleteScheduleItem(ddb, record.machineSerialNumber, record.schedulingId, now, loggedInUser.toUpperCase())));
      await Promise.all(newRecords.map(record => putScheduleItem(ddb, record, now, loggedInUser.toUpperCase())));
      
      // set data
      const indexOfMachine = machineData.findIndex(m => m.serialNumber === openMachine.serialNumber);
      let newOpenMachine = cloneDeep(openMachine);
      newOpenMachine.schedule = cloneDeep(newOpenMachine.newSchedule);
      newOpenMachine.releasedJobs = cloneDeep(newOpenMachine.newReleasedJobs);
      const newMachineData = cloneDeep(machineData);
      newMachineData[indexOfMachine] = newOpenMachine;
      updateOpenMachine(newOpenMachine);
      updateMachineData(newMachineData);
      window.alert(`Schedule saved for ${openMachine.machineLocator}-${openMachine.commonName}`);
    }
    catch(e) {
      console.error('handleSaveClick error ->', e);
    }
    finally {
      updateLoadingMessage(null);
    }
  };
  
  const handleResetClick = () => {
    if(window.confirm('Are you sure you want to reset your changes?')) resetChanges();
  };
  
  const resetChanges = () => {
    setSelectedStoppageReason('NO SCHEDULE');
    setStoppageTime('1.0');
    setStoppageStartTime(null);
    const indexOfMachine = machineData.findIndex(m => m.serialNumber === openMachine.serialNumber);
    let newOpenMachine = cloneDeep(openMachine);
    newOpenMachine.newSchedule = cloneDeep(newOpenMachine.schedule);
    newOpenMachine.newReleasedJobs = cloneDeep(newOpenMachine.releasedJobs);
    const newMachineData = cloneDeep(machineData);
    newMachineData[indexOfMachine] = newOpenMachine;
    updateOpenMachineSelectedJob(null);
    updateInsertJobType('DYNAMIC');
    updateMachineData(newMachineData);
    updateOpenMachine(newOpenMachine);
  };
  
  const showInsertButtons = openMachineSelectedJob != null &&
    (openMachineSelectedJob !== 'STOPPAGE' || insertJobType === 'DYNAMIC' || stoppageStartTime != null) &&
    insertJobType === 'DYNAMIC' && !authorizedModules.includes('READ_ONLY');
  
  const locationObj = openMachine ? locationData.get(openMachine.machineLocator) : null;
  const backgroundData = locationObj ?
    buildGradientString(timeNow, timeNow + totalTime, locationObj.shiftTimes, (windowDimensions.width - 40) / (totalTime / 3600000)) :
    null;
  
  if(!openMachine) return null;
  return (
    <>
      <div
        style={{
          ...styles.mainContainer,
          backgroundColor: GLOBAL_STYLES[colorScheme].bgColor,
        }}
      >
        <div
          style={{
            ...styles.heading,
            borderBottomColor: GLOBAL_STYLES[colorScheme].fgColor,
          }}
        >
          <h1 style={{ margin: 0 }}>{`${openMachine.machineLocator}-${openMachine.commonName}`}</h1>
          <div style={styles.buttonGroup}>
            {
              !authorizedModules.includes('READ_ONLY') ?
                <>
                  {/* SAVE BUTTON */}
                  <ToolbarButton
                    icon="fa-floppy-o"
                    label="SAVE"
                    disabled={!changed}
                    onClick={handleSaveClick}
                  />
                  
                  {/* RESET BUTTON */}
                  <ToolbarButton
                    icon="fa-undo"
                    label="RESET"
                    disabled={!changed}
                    onClick={handleResetClick}
                  />
                </> :
                null
            }
            
            {/* CLOSE BUTTON */}
            <ToolbarButton
              icon="fa-times"
              label="CLOSE"
              onClick={handleCloseClick}
            />
          </div>
        </div>
        <div style={styles.pageContainer}>
          <div style={styles.timelineContainer}>
            <div style={styles.chunkContainer}>
              {openMachine.newSchedule.length ?
                openMachine.newSchedule.map((chunkObj, chunkIndex) => {
                  const jobs = chunkObj.jobNumbers ?
                    openMachine.jobs.find(jobArr => jobArr.some(job => job.jobNumber === chunkObj.jobNumbers[0])) :
                    null;
                  const partNumbers = jobs ? jobs.map(j => j.partNumber) : [];
                  let actualChunks = [chunkObj];
                  if(!chunkObj.isStoppage && chunkObj.periods) {
                    actualChunks = chunkObj.periods;
                  }
                  return actualChunks.map((aChunkObj, aChunkIndex) => {
                    const chunkWidth = totalTime > 0 ? ((aChunkObj.endTime - aChunkObj.startTime) / totalTime) * (windowDimensions.width - 40) : 0;
                    const bgColor = typeToColorMap(
                      chunkObj.isStoppage ? 'STOPPAGE' : aChunkObj.type === 'DOWN' ? 'DOWN' : 'JOB',
                      chunkObj.isCurrent,
                      false,
                      jobs?.length ? jobs[0].unit : null,
                    );
                    return (
                      <div
                        key={`${chunkIndex}|${aChunkIndex}`}
                        style={{
                          ...styles.chunk,
                          width: chunkWidth,
                          backgroundColor: bgColor,
                          borderRightColor: GLOBAL_STYLES[colorScheme].fgColor,
                          borderLeftColor: chunkIndex === 0 ? GLOBAL_STYLES[colorScheme].fgColor : null,
                          borderLeftWidth: chunkIndex === 0 ? 1 : null,
                          borderLeftStyle: chunkIndex === 0 ? 'solid' : null,
                          borderTopColor: GLOBAL_STYLES[colorScheme].fgColor,
                          borderBottomColor: GLOBAL_STYLES[colorScheme].fgColor,
                        }}
                      >
                        <p style={styles.chunkText}>
                          {
                            chunkObj.stoppageReason ?
                              getAcronym(chunkObj.stoppageReason) :
                              aChunkObj.type === 'RUNNING' ?
                                partNumbers.join(' & ') :
                                ''
                          }
                        </p>
                      </div>
                    );
                  });
                }) :
                <div
                  style={{
                    ...styles.emptyTimeline,
                    borderColor: GLOBAL_STYLES[colorScheme].fgColor,
                    width: windowDimensions.width - 40,
                  }}
                />
              }
            </div>
            <div style={styles.shiftLabelContainer}>
              <div
                style={{
                  ...styles.shiftContainer,
                  width: windowDimensions.width - 40,
                }}
              >
                {
                  backgroundData ?
                    <svg width={backgroundData.totalWidth} height={20}>
                      {backgroundData.rectangles.map(({ color, x, width }, index) =>
                        <rect key={index} x={x} width={width} height={20} style={{ fill: color }}/>)}
                    </svg> :
                    null
                }
              </div>
              <div style={styles.labelContainer}>
                <div
                  style={{
                    ...styles.timeCell,
                    width: (windowDimensions.width - 40) / 3,
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                  }}
                >
                  <div style={{ ...styles.verticalDivider, backgroundColor: GLOBAL_STYLES[colorScheme].fgColor }}/>
                  <p style={styles.timeLabel}>{convertTimestampMD(timeNow)}</p>
                </div>
                <div
                  style={{
                    ...styles.timeCell,
                    width: (windowDimensions.width - 40) / 3,
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                  }}
                >
                  <div style={{ ...styles.verticalDivider, backgroundColor: GLOBAL_STYLES[colorScheme].fgColor }}/>
                  <p style={styles.timeLabel}>{convertTimestampMD(timeNow + (totalTime / 2))}</p>
                </div>
                <div
                  style={{
                    ...styles.timeCell,
                    width: (windowDimensions.width - 40) / 3,
                    alignItems: 'flex-end',
                    justifyContent: 'flex-start',
                  }}
                >
                  <div style={{ ...styles.verticalDivider, backgroundColor: GLOBAL_STYLES[colorScheme].fgColor }}/>
                  <p style={styles.timeLabel}>{convertTimestampMD(timeNow + totalTime)}</p>
                </div>
              </div>
            </div>
          </div>
          
          <div style={styles.jobsMainContainer}>
            {/* RELEASED JOBS CONTAINER */}
            {
              !authorizedModules.includes('READ_ONLY') ?
                <div
                  style={{
                    ...styles.pressContainer,
                    backgroundColor: GLOBAL_STYLES[colorScheme].textInputColor,
                    borderColor: GLOBAL_STYLES[colorScheme].fgColor,
                  }}
                >
                  <div
                    style={{
                      ...styles.pressHeaderContainer,
                      borderBottomColor: GLOBAL_STYLES[colorScheme].fgColor,
                    }}
                  >
                    <h5 style={styles.pressHeaderTitle}>RELEASED JOBS</h5>
                    <Form.Control
                      as="select"
                      value={insertJobType}
                      onChange={e => updateInsertJobType(e.target.value)}
                      size="sm"
                      onClick={e => e.stopPropagation()}
                    >
                      <option>DYNAMIC</option>
                      <option>STATIC</option>
                    </Form.Control>
                  </div>
                  <div
                    style={{
                      ...styles.itemColumn,
                      backgroundColor: GLOBAL_STYLES[colorScheme].textInputColor,
                      paddingBottom: 5,
                    }}
                  >
                    <div
                      style={{
                        ...styles.stoppageContainer,
                        backgroundColor: openMachineSelectedJob === 'STOPPAGE' && insertJobType === 'DYNAMIC' ?
                          GLOBAL_STYLES.CONSTANTS.orangeColor :
                          GLOBAL_STYLES.CONSTANTS.blueColor,
                        borderColor: GLOBAL_STYLES[colorScheme].fgColor,
                        cursor: insertJobType === 'DYNAMIC' ? 'pointer' : 'default',
                      }}
                      onClick={insertJobType === 'DYNAMIC' ?
                        openMachineSelectedJob === 'STOPPAGE' ?
                          () => updateOpenMachineSelectedJob(null) :
                          () => updateOpenMachineSelectedJob('STOPPAGE') :
                        null
                      }
                    >
                      <Form.Group style={{ marginBottom: 5 }}>
                        <Form.Label column={null}>STOPPAGE REASON</Form.Label>
                        <Form.Control
                          as="select"
                          value={selectedStoppageReason}
                          onChange={e => setSelectedStoppageReason(e.target.value)}
                          size="sm"
                          onClick={e => e.stopPropagation()}
                        >
                          <option>NO SCHEDULE</option>
                          <option>PREVENTATIVE MAINTENANCE</option>
                          <option>MAINTENANCE</option>
                          <option>MOLD CHANGE</option>
                          <option>JOB CHANGE</option>
                          <option>COLOR CHANGE</option>
                        </Form.Control>
                      </Form.Group>
                      <Form.Group style={{ marginBottom: 5 }}>
                        <Form.Label column={null}>DOWNTIME (HOURS)</Form.Label>
                        <Form.Control
                          type="number"
                          step={0.1}
                          value={stoppageTime}
                          onChange={e => setStoppageTime(e.target.value)}
                          onClick={e => e.stopPropagation()}
                        />
                      </Form.Group>
                      {
                        insertJobType === 'STATIC' ?
                          <>
                            <Form.Group
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                marginBottom: 5,
                              }}
                            >
                              <DatePicker
                                selected={stoppageStartTime}
                                onChange={date => setStoppageStartTime(date)}
                                minDate={new Date()}
                                isClearable
                                showTimeSelect
                                dateFormat="Pp"
                                timeIntervals={15}
                                placeholderText="Select start date..."
                                className="form-control form-control-sm"
                                onClick={e => e.stopPropagation()}
                              />
                            </Form.Group>
                            <Button
                              variant="danger"
                              size="sm"
                              onClick={() => {
                                insertStoppage();
                                setStoppageStartTime(null);
                              }}
                              disabled={stoppageStartTime == null || stoppageStartTime.getTime() < timeNow}
                            >
                              <i
                                className="fa fa-plus fa-lg"
                                style={{ color: GLOBAL_STYLES.CONSTANTS.white }}
                              />
                            </Button>
                          </> :
                          null
                      }
                    </div>
                    {openMachine.newReleasedJobs.map((jobArr, index) => <ReleasedJob
                      key={index}
                      jobArr={jobArr}
                      index={index}
                      timeNow={timeNow}
                      insertJob={(jobArrIndex, staticStartTime) => insertJob(jobArrIndex, null, staticStartTime)}
                    />)}
                  </div>
                </div> :
                null
            }
            
            {/* SCHEDULED JOBS CONTAINER */}
            <div
              style={{
                ...styles.pressContainer,
                backgroundColor: GLOBAL_STYLES[colorScheme].textInputColor,
                borderColor: GLOBAL_STYLES[colorScheme].fgColor,
              }}
            >
              <div
                style={{
                  ...styles.pressHeaderContainer,
                  borderBottomColor: GLOBAL_STYLES[colorScheme].fgColor,
                }}
              >
                <h5 style={styles.pressHeaderTitle}>SCHEDULED JOBS</h5>
              </div>
              <div
                style={{
                  ...styles.itemColumn,
                  backgroundColor: GLOBAL_STYLES[colorScheme].textInputColor,
                }}
              >
                {
                  showInsertButtons &&
                  (!openMachine.newSchedule.filter(s => !s.isGenerated).length ||
                    openMachine.newSchedule.filter(s => !s.isGenerated)[0].startTime > timeNow ||
                    !openMachine.newSchedule.filter(s => s.isCurrent).length) ?
                    <Button
                      style={{
                        ...styles.insertButton,
                        top: -15.5,
                      }}
                      variant="danger"
                      size="sm"
                      onClick={() => handleInsert(openMachineSelectedJob, 0)}
                    >
                      <i
                        className="fa fa-plus fa-lg"
                        style={{ color: GLOBAL_STYLES.CONSTANTS.white }}
                      />
                    </Button>
                    :
                    null
                }
                {openMachine.newSchedule.map((scheduleObj, index, array) => {
                  if(scheduleObj.isCurrent) return <React.Fragment key={index}>
                    <CurrentJob
                      jobs={openMachine.jobs}
                      scheduleObj={scheduleObj} timeNow={timeNow}
                      isLast={index === array.length - 1}
                      updateShifts={shiftArr => updateShifts(shiftArr, index)}
                    />
                    {
                      showInsertButtons ?
                        <Button
                          style={{
                            ...styles.insertButton,
                            top: index === array.length - 1 ? -35.5 : -15.5,
                          }}
                          variant="danger"
                          size="sm"
                          onClick={() => handleInsert(openMachineSelectedJob, index + 1)}
                        >
                          <i
                            className="fa fa-plus fa-lg"
                            style={{ color: GLOBAL_STYLES.CONSTANTS.white }}
                          />
                        </Button>
                        :
                        null
                    }
                  </React.Fragment>;
                  if(scheduleObj.isStoppage) return <React.Fragment key={index}>
                    <Stoppage
                      scheduleObj={scheduleObj}
                      isLast={index === array.length - 1}
                      removeStoppage={() => removeStoppage(index)}
                    />
                    {
                      showInsertButtons && !scheduleObj.isGenerated && !scheduleObj.isChangeover ?
                        <Button
                          style={{
                            ...styles.insertButton,
                            top: index === array.length - 1 ? -35.5 : -15.5,
                          }}
                          variant="danger"
                          size="sm"
                          onClick={() => handleInsert(openMachineSelectedJob, index + 1)}
                        >
                          <i
                            className="fa fa-plus fa-lg"
                            style={{ color: GLOBAL_STYLES.CONSTANTS.white }}
                          />
                        </Button>
                        :
                        null
                    }
                  </React.Fragment>;
                  return <React.Fragment key={index}>
                    <ScheduledJob
                      jobs={openMachine.jobs}
                      scheduleObj={scheduleObj}
                      isLast={index === array.length - 1}
                      removeJob={jobArr => removeJob(index, jobArr)}
                      updateNote={note => updateNote(note, index)}
                      updateShifts={shiftArr => updateShifts(shiftArr, index)}
                      updatePriority={priority => updatePriority(priority, index)}
                      updateEngineerStartup={engineerStart => updateEngineerStartup(engineerStart, index)}
                    />
                    {
                      showInsertButtons ?
                        <Button
                          style={{
                            ...styles.insertButton,
                            top: index === array.length - 1 ? -35.5 : -15.5,
                          }}
                          variant="danger"
                          size="sm"
                          onClick={() => handleInsert(openMachineSelectedJob, index + 1)}
                        >
                          <i
                            className="fa fa-plus fa-lg"
                            style={{ color: GLOBAL_STYLES.CONSTANTS.white }}
                          />
                        </Button>
                        :
                        null
                    }
                  </React.Fragment>;
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <JobNotesModal/>
    </>
  );
};

const styles = {
  mainContainer: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    zIndex: 600,
    opacity: 0.99,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
  },
  heading: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid',
    padding: '10px 20px',
  },
  pageContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    padding: 20,
    overflowY: 'auto',
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'row',
  },
  timelineContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  chunkContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'no-wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  chunk: {
    height: 40,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    boxSizing: 'border-box',
    borderRightWidth: 1,
    borderRightStyle: 'solid',
    overflow: 'hidden',
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
  },
  chunkText: {
    margin: 0,
    padding: 0,
    whiteSpace: 'no-wrap',
    marginLeft: 4,
    color: GLOBAL_STYLES.CONSTANTS.white,
  },
  labelContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'no-wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  timeCell: {
    height: 60,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  verticalDivider: {
    width: 1,
    height: 30,
    minHeight: 30,
  },
  timeLabel: {
    margin: 0,
    padding: 0,
  },
  jobsMainContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'stretch',
  },
  pressContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    borderRadius: 15,
    borderWidth: 1,
    borderStyle: 'solid',
    margin: 7.5,
    flex: 1,
  },
  pressHeaderContainer: {
    borderTopRightRadius: 15,
    borderTopLeftRadius: 15,
    padding: 7,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'stretch',
  },
  pressHeaderTitle: {
    fontSize: '2em',
    padding: 0,
    margin: 0,
    textAlign: 'center',
  },
  itemColumn: {
    flex: 1,
    borderBottomLeftRadius: 15,
    borderBottomRightRadius: 15,
    minHeight: 75,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
  },
  insertButton: {
    alignSelf: 'center',
    position: 'relative',
    marginBottom: -31,
  },
  stoppageContainer: {
    userSelect: 'none',
    padding: 5,
    margin: 5,
    marginBottom: 0,
    borderRadius: 10,
    borderWidth: 1,
    borderStyle: 'solid',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
  },
  shiftLabelContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
  },
  shiftContainer: {
    height: 20,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginBottom: -20,
    overflow: 'hidden',
  },
  emptyTimeline: {
    height: 40,
    boxSizing: 'border-box',
    borderWidth: 1,
    borderStyle: 'solid',
  },
};

export default connect(mapStateToProps, mapDispatchToProps)(EditSchedule);